// extracted by mini-css-extract-plugin
export default {"logo":"kQHKc8EzUTpnA0YVtHkX","kids-logo":"mR6iHZvywCluQk80JrOA","kidsLogo":"mR6iHZvywCluQk80JrOA"};